import { useEffect, useState } from 'react';

export const useHasMounted = (callback: () => void) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    callback();
  }, [callback]);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return hasMounted;
};
